import React, { useRef, useState, useEffect, useContext, useMemo } from 'react'
import { PicturePreview } from 'baseComponent'
import getImage from 'common/getImage'
import RenderBoxList from './renderBoxList'
import OuterChange from './outerChange'
import NewAnnotate from '../annotate/newAnnotate'
import { NoteLabel } from '../annotate/note'
import { IMAGE_DETAIL_TAB } from '../infoView'
import styles from './index.module.less'

export const adaImage = (imgInfo, canvasDom) => {
  const canvasWidth = canvasDom.width
  const canvasHeight = canvasDom.height > document.body.clientHeight ? document.body.clientHeight : canvasDom.height
  let wrapperWidth = canvasWidth
  let wrapperHeight = canvasHeight
  console.log('imgInfo', imgInfo, canvasDom.height)
  if ((imgInfo.width / imgInfo.height) > (canvasWidth / canvasHeight)) {
    wrapperWidth = canvasWidth
    wrapperHeight = (imgInfo.height * canvasWidth) / imgInfo.width
  } else {
    wrapperHeight = canvasHeight
    wrapperWidth = (imgInfo.width * canvasHeight) / imgInfo.height
  }
  return {
    width: wrapperWidth,
    height: wrapperHeight
  }
}

export default ({
  onChangeInnerIndex,
  innerIndex,
  imgInfoList,
  currentImage,
  onBanOperation,
  onOuterChange,
  outerMaxLength,
  outerIndex,
  scale,
  setScale,
  showNoteLabel,
  showBox,
  content
}) => {
  const {
    tabValue,
    notes,
    onInitNotes,
    setNotes,
    isDraw,
    onIsDraw,
    isMove,
    onIsMove,
    activeNoteIndex,
    onActiveNoteIndex,
    isAnnotate,
    onIsAnnotate,
    isShowRight,
    isPage,
    boxIndex,
    onBoxIndex,
  }:any = useContext(content)
  const $annotateContainer = useRef(null)
  const { mainUrl, width, height } = currentImage || {}
  const picInfo = { src: mainUrl, picWidth: width, picHeight: height }
  const [originImage, setOriginImage] = useState<any>({
    width,
    height,
  })

  useEffect(() => {
    setOriginImage({
      width,
      height,
    })
    getImage(mainUrl).then((img) => {
      setOriginImage({
        width: img.naturalWidth,
        height: img.naturalHeight,
      })
    }).catch(() => {
      setOriginImage({
        width,
        height,
      })
    })
  }, [currentImage])

  const annotationWrapStyle = useMemo(() => {
    if (tabValue === IMAGE_DETAIL_TAB.ANNOTATION) {
      return {}
    }
    return {
      paddingLeft: '214px',
      paddingRight: '110px',
    }
  }, [tabValue])

  return <div
    className={styles['imgs-and-pagination']}
    ref={$annotateContainer}
    style={annotationWrapStyle}
  >
    {
      !isPage && <OuterChange
        maxLength={outerMaxLength}
        outerIndex={outerIndex}
        onOuterChange={onOuterChange}
      />
    }
    <div className={styles['meinian-image-detail-picture']}>
      {
          tabValue !== IMAGE_DETAIL_TAB.ANNOTATION && <Main
            mainUrl={mainUrl}
            originImage={originImage}
            picInfo={picInfo}
            onBanOperation={onBanOperation}
            notes={notes}
            showBox={showBox}
            boxIndex={boxIndex}
            key={tabValue}
            onBoxIndex={onBoxIndex}
            currentImage={currentImage}
            showNoteLabel={showNoteLabel}
          >
            {
              tabValue !== IMAGE_DETAIL_TAB.ANNOTATION && <>
                <Arrow
                  step={-1}
                  imgInfoList={imgInfoList}
                  innerIndex={innerIndex}
                  setInnerIndex={onChangeInnerIndex}
                  type="prev"
                />
                <Arrow
                  step={1}
                  imgInfoList={imgInfoList}
                  innerIndex={innerIndex}
                  setInnerIndex={onChangeInnerIndex}
                  type="next"
                />
              </>
            }
          </Main>
      }
      {
          tabValue === IMAGE_DETAIL_TAB.ANNOTATION && <NewAnnotate
            className="img-annotate-container"
            imageInfo={currentImage}
            originImage={originImage}
            scale={scale}
            setScale={setScale}
            isAnnotate={isAnnotate}
            setIsAnnotate={onIsAnnotate}
            notes={notes}
            setNotes={setNotes}
            fetchNotes={onInitNotes}
            isMove={isMove}
            setIsMove={onIsMove}
            activeNoteIndex={activeNoteIndex}
            setActiveNoteIndex={onActiveNoteIndex}
            isDraw={isDraw}
            setIsDraw={onIsDraw}
            isShowRight={isShowRight}
          />
        }
    </div>
  </div>
}

const Main = ({ mainUrl, originImage, picInfo, onBanOperation, notes, showBox, boxIndex, onBoxIndex, currentImage, showNoteLabel, children }) => {
  const domRef = useRef(null)
  const [imageSize, setImageSize] = useState(originImage)

  useEffect(() => {
    const onResize = () => {
      const imageSize = adaImage(originImage, {
        width: domRef.current.clientWidth,
        height: domRef.current.clientHeight,
      })
      setImageSize(imageSize)
    }
    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [originImage, domRef.current])

  return <div className={styles.picture} ref={domRef}>
    {children}
    <div style={{ ...imageSize, position: 'relative' }}>
      <img src={mainUrl} className={styles['meinian-image-detail-main-image']} />
      <div
        className={styles.scale}
        onClick={() => {
          PicturePreview.show(picInfo, onBanOperation)
          onBanOperation(true)
        }}
      />
      {
        showBox && <RenderBoxList
          currentImage={currentImage}
          boxIndex={boxIndex}
          onBoxIndex={onBoxIndex}
          originImage={originImage}
        />
      }
      {
        showNoteLabel && <div>
          {notes?.map((item, index) => <NoteLabel
            data={item}
            index={notes.length - index}
            key={index}
          />)}
        </div>
      }
    </div>
  </div>
}

const Arrow = ({ imgInfoList, type, step, innerIndex, setInnerIndex }) => (
  <div
    className={`arrow-container ${type}`}
    onClick={(e) => { e.stopPropagation(); setInnerIndex(innerIndex + step) }}
    style={{ display: imgInfoList[innerIndex + step] ? 'flex' : 'none' }}
  />)
